import React from 'react';
import { Helmet } from 'react-helmet';

type SeoProps = {
    title: string;
    description: string;
    path: string;
    robots?: string;
    imagePath?: string;
};

const SITE_NAME = 'Kempeleen Pyöräpaja';
const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://kempeleenpyorapaja.fi').replace(/\/$/, '');
const DEFAULT_IMAGE = '/logo192.png';

const getAbsoluteUrl = (path: string) => {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    return `${SITE_URL}${normalizedPath}`;
};

export default function Seo({
    title,
    description,
    path,
    robots = 'index,follow,max-image-preview:large',
    imagePath = DEFAULT_IMAGE,
}: SeoProps) {
    const canonicalUrl = getAbsoluteUrl(path);
    const imageUrl = getAbsoluteUrl(imagePath);
    const pageTitle = `${title} | ${SITE_NAME}`;

    return (
        <Helmet>
            <html lang="fi" />
            <title>{pageTitle}</title>
            <meta name="description" content={description} />
            <meta name="robots" content={robots} />
            <link rel="canonical" href={canonicalUrl} />
            <meta property="og:locale" content="fi_FI" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={pageTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={imageUrl} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={pageTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={imageUrl} />
        </Helmet>
    );
}